import React, { Component } from 'react';
import Axios from 'axios';

const tableStyles = {
    wrapper: {
        marginTop: '24px',
        marginBottom: '54px',
    },
    label: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 700,
        fontSize: '19px',
        color: '#5B595B',
        marginBottom: '12px',
        display: 'block',
    },
    table: {
        width: 'auto',
        borderCollapse: 'collapse',
        border: 'none',
        marginBottom: '30px',
    },
    tdOdd: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '8px 24px',
        border: '1px solid #BCBEC0',
        backgroundColor: '#EEEFF0',
    },
    tdEven: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '8px 24px',
        border: '1px solid #BCBEC0',
        backgroundColor: '#FFFFFF',
    },
    tdOddBold: {
        fontWeight: 700,
    },
    tdEvenBold: {
        fontWeight: 700,
    },
};

class FichaTecnicaEmpreendimento extends Component {

    state = {
        loading: false,
        ficha: null,
    }

    componentDidMount() {
        this.loadFicha();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.buildingId !== this.props.buildingId) {
            this.loadFicha();
        }
    }

    loadFicha = async () => {
        if (!this.props.buildingId) {
            this.setState({ ficha: null });
            return;
        }

        try {
            this.setState({ loading: true });
            const response = await Axios.get(`/empreendimento/ficha-tecnica/${this.props.buildingId}`);
            this.setState({ ficha: response.data });
        } catch (error) {
            this.setState({ ficha: null });
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { ficha, loading } = this.state;

        if (loading || !ficha) return null;

        const areas = ficha.areas_lazer || [];
        const metade = Math.ceil(areas.length / 2);
        const colunas = [areas.slice(0, metade), areas.slice(metade)];

        return (
            <div style={tableStyles.wrapper}>
                <span style={tableStyles.label}>Ficha técnica do empreendimento</span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '32px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                    <table style={tableStyles.table}>
                        <tbody>
                            <tr>
                                <td style={{ ...tableStyles.tdOdd, ...tableStyles.tdOddBold }}>Incorporadora</td>
                                <td style={tableStyles.tdOdd}>{ficha.incorporadora || '—'}</td>
                            </tr>
                            <tr>
                                <td style={{ ...tableStyles.tdEven, ...tableStyles.tdEvenBold }}>Construtora</td>
                                <td style={tableStyles.tdEven}>{ficha.construtora || '—'}</td>
                            </tr>
                            <tr>
                                <td style={{ ...tableStyles.tdOdd, ...tableStyles.tdOddBold }}>Lançamento</td>
                                <td style={tableStyles.tdOdd}>{ficha.lancamento || '—'}</td>
                            </tr>
                            <tr>
                                <td style={{ ...tableStyles.tdEven, ...tableStyles.tdEvenBold }}>Entrega</td>
                                <td style={tableStyles.tdEven}>{ficha.entrega || '—'}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={tableStyles.table}>
                        <tbody>
                            <tr>
                                <td style={{ ...tableStyles.tdOdd, ...tableStyles.tdOddBold }}>Unidades lançadas</td>
                                <td style={tableStyles.tdOdd}>{ficha.unidades_lancadas ?? '—'}</td>
                            </tr>
                            <tr>
                                <td style={{ ...tableStyles.tdEven, ...tableStyles.tdEvenBold }}>Torres</td>
                                <td style={tableStyles.tdEven}>{ficha.torres ?? '—'}</td>
                            </tr>
                            <tr>
                                <td style={{ ...tableStyles.tdOdd, ...tableStyles.tdOddBold }}>Andares</td>
                                <td style={tableStyles.tdOdd}>{ficha.andares ?? '—'}</td>
                            </tr>
                            <tr>
                                <td style={{ ...tableStyles.tdEven, ...tableStyles.tdEvenBold }}>Elevadores</td>
                                <td style={tableStyles.tdEven}>{ficha.elevadores ?? '—'}</td>
                            </tr>
                        </tbody>
                    </table>

                    {areas.length > 0 && (
                        <table style={tableStyles.table}>
                            <tbody>
                                <tr>
                                    <td style={{ ...tableStyles.tdOdd, ...tableStyles.tdOddBold, textAlign: 'center' }} colSpan={2}>Áreas de lazer</td>
                                </tr>
                                <tr>
                                    <td style={{ ...tableStyles.tdEven, textAlign: 'left' }} colSpan={2}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 32px' }}>
                                            {colunas.map((coluna, colIndex) => (
                                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }} key={colIndex}>
                                                    {coluna.map((area, index) => (
                                                        <li key={index}>{area}</li>
                                                    ))}
                                                </ul>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        );
    }
}

export default FichaTecnicaEmpreendimento;
